const initialState = {
  size: 1024,
};
const SizeForMobileReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_SIZE_FOR_MOBILE":
      return (initialState.size = action.payload);
    default:
      return state;
  }
};

export default SizeForMobileReducer;
